export const GET_PROJECT_CATEGORIES = 'projectCategories/GET_PROJECT_CATEGORIES';
export const GET_PROJECT_CATEGORIES_SUCCESS =
  'projectCategories/GET_PROJECT_CATEGORIES_SUCCESS';
export const GET_PROJECT_CATEGORIES_ERROR =
  'projectCategories/GET_PROJECT_CATEGORIES_ERROR';
